jQuery(document).ready(
	function($) {
		// Create navbar class
		const navbar = '.navbar__main';
		// Create colors
		const colorGreen = '#038663';
		const colorBlack = '#212529';
		// Add placeholder text in search bar
		const searchBarText = 'Search this website';
		$('#searchform input').attr('placeholder', searchBarText );
		// Set nav instate
		$( navbar + '--navigation' ).find('.dropdown-menu').find('.active').parents('.nav-item').find('.nav-link').css( 'color', colorGreen );
		// On hamburger menu click
		$( navbar + '--hamburger_menu').click(
			function() {
				if ( $( navbar + '--navigation' ).css('display' ) == 'none' ) {
					// Show menu
					$( navbar + '--navigation').show();
					// Change icon color
					$( this ).css( 'color', colorBlack );
				} else {
					// Hide menu
					$( navbar + '--navigation').hide();
					// Change icon color
					$( this ).css( 'color', colorGreen );
				}
			}
		);
		// On resize the browser window
		$( window ).resize(
			function () {
				// If the window width is larger than tablet
				if ( $( window ).width() > 975 ) {
					$( navbar + '--navigation').show();
				} else {
					$( navbar + '--navigation').hide();
				}
			}
		);
		// On dropdown menu item click
		$( '.dropdown-item').click(
			function () {
				// If a link targets a new tab
				if ( '_blank' == $(this).attr('target') ) {
					// Open the link in a new tab
					window.open( $(this).attr('href'), '_blank' );
				} else {
					// Open the link in the same window
					window.open( $(this).attr('href'), '_self' );
				}
			}
		);
		// On members menu click (displayed when logged in)
		const membersMenu = '.navbar__main__login__members_menu';
		$( membersMenu ).click(
			function () {
				if ( $( this ).hasClass( 'open' ) ) {
					// Change the button to grey
					$( this ).find( membersMenu + '--button' ).css( 'background-color', '#038663' );
					// Close the dropdown
					$( this ).removeClass( 'open' );
				} else {
					// Change the button to green
					$( this ).find( membersMenu + '--button' ).css( 'background-color', '#212529' );
					// Open the dropdown
					$( this ).addClass( 'open' );
				}
			}
		);
	}
);
